<template>
  <div class="card skeleton">
    <div class="card-body card-padding">
      <div class="row">
        <div class="col-xs-2">
          <div class="skeleton-circle-xl skeleton-circle-profile m-b-10" />
        </div>
        <div class="col-xs-10">
          <div class="row">
            <div class="col-xs-7 m-b-10">
              <div>
                <div class="skeleton-part-md skeleton-width-xs" />
              </div>
              <div class="skeleton-part-sm skeleton-width-md" />
              <div class="skeleton-part-sm skeleton-width-sm" />
            </div>
            <div class="col-xs-5">
              <div class="row-flex align-items-center">
                <div class="col-sm-3">
                  <div class="skeleton-circle-xl skeleton-circle-currency" />
                </div>
                <div class="col-sm-9">
                  <div class="skeleton-part-md skeleton-width-xs" />
                  <div class="skeleton-part-sm skeleton-width-sm" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="skeleton-part-sm skeleton-width-xs" />
        <div class="clear" />
      </div>
      <div>
        <div class="skeleton-part-sm skeleton-width-sm" />
        <div class="clear" />
      </div>
    </div>
    <div class="card-body card-padding bgm-graywhite f-14">
      <div class="row">
        <div class="col-sm-9">
          <div class="skeleton-part-sm skeleton-width-lg" />
          <div class="skeleton-part-sm skeleton-width-lg" />
          <div class="skeleton-part-sm skeleton-width-md" />
        </div>
        <div class="col-sm-3 text-right">
          <div class="skeleton-part-sm skeleton-width-sm" />
          <div class="skeleton-part-sm skeleton-width-xs" />
        </div>
      </div>
    </div>
    <div class="p-15 text-right row">
      <div class="col-sm-offset-7 col-sm-5">
        <div class="skeleton-part-sm skeleton-width-xl m-t-0 float-right" />
        <div class="clear" />
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.skeleton-circle-profile {
  width: 80px;
  height: 80px;
}

.skeleton-circle-currency {
  width: 40px;
  height: 40px;
}
</style>
